import React from 'react';
import Dialog from '@mui/material/Dialog';
import { Form, Formik, FormikHelpers } from 'formik';
import { object, string , ref} from 'yup';
import { UpdatePasswordDialogValues } from 'src/models/UpdatePasswordDialog.model';
import UpdatePasswordDialog from './UpdatePasswordDialog';
import { useUpdateStudentPasswordMutation } from 'src/services/StudentServices';
import { showToast } from 'src/utils/showToaster';



type Props = {
  onClose: () => void;
  studentId:string ;
  setStudentId:any;
  
};

const UpdatePasswordDialogWrapper = ({ onClose , setStudentId , studentId  }: Props) => {

    const[updatePassword] = useUpdateStudentPasswordMutation()

  // Form Initial Values
  const initialValues: UpdatePasswordDialogValues = {
    newPassword:'' ,
    confrimPassword:'' 
  };

  // Validation Schema
  const validationSchema = object().shape({
    newPassword: string().trim().min(4, 'password must be at least 5 characters long.').required('password is required'),
    confrimPassword: string().trim().min(4, 'password must be at least 5characters long.').required('confirm password is required')
        .oneOf([ref("newPassword")], "Passwords do not match"),
  });

  // Handle Submit
  const handleSubmit = (
    values: UpdatePasswordDialogValues,
    { setSubmitting, resetForm }: FormikHelpers<UpdatePasswordDialogValues>
  ) => { 
    const formattedValues ={
        newPassword:values?.confrimPassword,
        studentId:studentId
    }
    updatePassword(formattedValues).then((res: any) => {
        if (res?.error) {
          showToast("error", res?.error?.data?.message);
        } else {
          if (res?.data?.status) {
            showToast("success", res?.data?.message);
            setStudentId('')
            onClose()
            resetForm();
          } else {
            showToast("error", res?.data?.message);
          }
        }
        setSubmitting(false);
      });
  };

  return (
    <Dialog open maxWidth='xs' fullWidth>
      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={handleSubmit}
      >
        {(formikProps) => (
          <Form>
            <UpdatePasswordDialog formikProps={formikProps} onClose={onClose} />
          </Form>
        )}
      </Formik>
    </Dialog>
  );
};

export default UpdatePasswordDialogWrapper;